import React from "react";
import styled from "styled-components";
import Container from "storybook-components/Container";
import { H3 } from "storybook-components/Typography";
import ResponsiveYoutubeVideo from "../shared/ResponsiveYoutubeVideo";

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray1};
  padding: 16px 0;
  ${props => props.theme.media.desktopUp`
    padding: 94px 0;
  `};
`;

const Heading = styled(H3)`
  color: ${({ theme }) => theme.colors.green5};
  text-align: left;
  ${({ theme }) => theme.media.desktopUp`
    text-align: center;
    margin: 0 auto 24px;
    max-width: 65rem;
  `};
`;

export default ({ heading, videoSrc }) => {
  return (
    <Wrapper>
      <Container>
        <Heading>{heading}</Heading>
        <ResponsiveYoutubeVideo src={videoSrc} />
      </Container>
    </Wrapper>
  );
};
